import React from 'react'
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className='w-full bg-blue-50 text-gray-500 text-center py-6 border-t-2 border-gray-300 mt-auto'>
        <p className="text-sm">{t("footer.copyright", { year: 2025 })}</p>
    </footer>
  )
}

export default Footer